import React from 'react';

import Breadcrumb from 'react-bootstrap/Breadcrumb';

export default function PageContainer({ title, crumbs, children }) {
  return (
    <div className="client-form-pages">
      <div className="container">
        <Breadcrumb>
          {crumbs.map((crumb, index) => (
            <Breadcrumb.Item key={index} href={crumb.url}>
              {crumb.title}
            </Breadcrumb.Item>
          ))}

          <Breadcrumb.Item active>{title}</Breadcrumb.Item>
        </Breadcrumb>
        {children}
      </div>
    </div>
  );
}
